import type React from 'react';
import ResourceCard, { type ResourceCardResource } from 'app/ui/components/molecules/navigation-card/resource-card';
import Grid from 'app/ui/components/molecules/grid';

export type ResourceGridProps = {
  resources: ResourceCardResource[];
  parentResourceListId?: string;
};

const ResourceGrid: React.FC<ResourceGridProps> = ({ resources, parentResourceListId }) => (
  <Grid elementsPerRow={2}>
    {resources.map((resource, index) => (
      <ResourceCard
        key={`resource-grid-${resource.id || index}`}
        resource={resource}
        parentResourceListId={parentResourceListId}
      />
    ))}
  </Grid>
);

export default ResourceGrid;
